<template>
  <div>
    <div class="main-pad" v-show="this.isApp == true ? false : true">
      <div class="touchBtn-con">
        <span class="touchBtn" @click="getQuickPayOrderList" v-show="isTouch">{{this.$t('gift.t29')}}</span>
        <div v-show="isLoading"><i class="el-icon-loading"></i></div>
      </div>
      <div class="tabal-con" v-show="isTabal">
        <div class="tabal-con-top">
          <div
            class="tabal-item"
            v-for="(item, index) in titleList"
            :key="index"
          >
            <div class="tabal-title">{{ item.title }}</div>
          </div>
        </div>
        <div class="record-con">
          <div
            class="record-item"
            v-for="(item, index) in recordList"
            :key="index"
          >
            <div class="record-title">{{ item.creation_time | toNull }}</div>
            <div class="record-title">{{ item.code | toNull}}</div>
            <div class="record-title">{{ item.chip | toNull}}</div>
            <div class="record-title">{{ item.transfer | toNull}}</div>
            <div class="record-title">{{ item.bankname | toNull}}</div>
            <div class="record-title">{{ item.bank_account | toNull}}</div>
            <div class="record-title">{{ item.order_status | tostatus }}</div>
          </div>
        </div>
        <div class="pagination-con">
            <el-pagination
          layout="prev, pager, next"
          :total="recordTotal"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
        >
        </el-pagination>
        </div>
      </div>
    </div>

    <div class="main-pad-h5" v-show="this.isApp == false ? false : true">
      <div class="touchBtn-con-h5">
        <span class="touchBtn" @click="getQuickPayOrderList" v-show="isTouch">{{this.$t('gift.t29')}}</span>
        <div v-show="isLoading"><i class="el-icon-loading"></i></div>
      </div>
      <div class="tabal-con-h5" v-show="isTabal">
        <div class="tabal-con-top">
          <div
            class="tabal-item"
            v-for="(item, index) in titleList"
            :key="index"
          >
            <div class="tabal-title">{{ item.title }}</div>
          </div>
        </div>
        <div class="record-con">
          <div
            class="record-item"
            v-for="(item, index) in recordList"
            :key="index"
          >
            <div class="record-title">{{ item.creation_time | toNull }}</div>
            <div class="record-title">{{ item.code | toNull}}</div>
            <div class="record-title">{{ item.chip | toNull}}</div>
            <div class="record-title">{{ item.transfer | toNull}}</div>
            <div class="record-title">{{ item.bankname | toNull}}</div>
            <div class="record-title">{{ item.bank_account | toNull}}</div>
            <div class="record-title">{{ item.order_status | tostatus }}</div>
          </div>
        </div>
        <div class="pagination-con">
            <el-pagination
          layout="prev, pager, next"
          :total="recordTotal"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
        >
        </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  // props: ["update"],
  filters:{
      tostatus(value){
                        if (value == "0") {
                            return "In process"
                        }else if (value == "1") {
                            return "complete"
                        }else if (value == "2") {
                            return "return"
                        }else if (value == "3") {
                            return "backout"
                        }
      },
      toNull(value){
          if(value==null||value==undefined||value==''){
              return '--'
          }else{
              return value
          }
      }
  },
  data() {
    return {
      isLoading:false,
      isTouch:true,
      isTabal:false,
      titleList: [
        {
          title: this.$t("gift.t18"),
        },
        {
          title: this.$t("gift.t19"),
        },
        {
          title: this.$t("gift.t20"),
        },
        {
          title: this.$t("gift.t21"),
        },
        {
          title: this.$t("gift.t22"),
        },
        {
          title: this.$t("gift.t23"),
        },
        {
          title: this.$t("gift.t24"),
        },
      ],
      recordList: [],
      recordTotal: 0,
      currentPage: 1,
      pageSize: 10,
    };
  },
  watch: {
  },
  created(){
  },
  computed: {
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
      tokenData(state){
        return state.tokenData;
      }
    }),
  },
  methods: {
    //获取支付订单接口
    getQuickPayOrderList() {
      var _that = this;
      _that.isTouch = false
      _that.isLoading = true
      let obj = {
        page: _that.currentPage,
        rows: _that.pageSize,
        token:_that.tokenData
      };
      this.$FucPost(this.$store.state.ip + "/getQuickPayOrderList", obj)
        .then(function (res) {
          console.log("getQuickPayOrderList-res", res);
          _that.$nextTick(()=>{
            _that.recordList = res.data;
          })
          console.log(' _that.recordList', _that.recordList)
          _that.recordTotal = res.total;
          _that.isLoading = false
          _that.isTabal = true
        })
        .catch((err) => {
          console.log(err);
        });
        
    },
    handleSizeChange(val) {
      this.pageSize = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getQuickPayOrderList(this.currentPage,this.pageSize);
      this.toTop()
    },
    // changeShow(){
    //     this.getQuickPayOrderList()
    // }
    toTop(){
            // chrome
  document.body.scrollTop = "-6.25rem"
  // firefox
  document.documentElement.scrollTop = "-6.25rem"
  // safari
  window.pageYOffset ="-6.25rem"
    }
  },
};
</script>
<style lang="less" scoped>
.main-pad {
  width: 100%;
  padding: 1.25rem;
  color: aliceblue;
  font-size: 0.875rem;
}
.tabal-con {
  width: 100%;
  margin: 0 auto;
}
.tabal-con-top {
  display: flex;
  align-items: center;
}
.tabal-item {
  background-color: rgba(255, 0, 0, 0.712);
  color: rgb(241, 121, 8);
  display: flex;
  justify-content: center;
  min-width: 11.5%;
  max-width: 11.5%;
  text-align: center;
  border: 0.0625rem solid #ffff;
  min-height: 1.25rem;
  max-height: 1.25rem;
  padding: 0.625rem 0.625rem;
  // line-height: 2.5rem;
}
.record-con {
  width: 100%;
}
.record-item {
  display: flex;
  align-items: center;
}
.record-title {
  color:rgba(0, 0, 0, 0.966);
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 11.5%;
  max-width: 11.5%;
  text-align: center;
  border: 0.0313rem solid #ffff;
  min-height: 2.5rem;
  max-height: 2.5rem;
  padding: 0.625rem 0.625rem;
  // line-height: 2.5rem;
  background-color:#d7ceb0;
}
.pagination-con{
    text-align: center;
    margin: 3.125rem 0;
}
.touchBtn-con{
  margin: 1.25rem 0;
  cursor: pointer;
  text-align: left;
}
.touchBtn-con-h5{
  text-align: left;
  cursor: pointer;
}
.touchBtn{
  text-align: left;
  padding: 0.3125rem 0.625rem;
  background-color:rgb(112, 109, 109);
  color: #ecc516;
}
.el-icon-loading{
  font-size: 1.875rem;
  z-index: 99999;
  color: #ecc516;
}
.main-pad-h5{
  width: 100%;
    color: aliceblue;
    font-size: 0.625rem;
    margin: 1.25rem 0;
}
.tabal-con-h5{
  overflow: scroll;
}
</style>